import React from "react";
import DashboardNavbar from "../components/navbars/DashboardNavbar";
import GoogleTranslate from "../components/translate/GoogleTranslate";

const DashboardLayout = ({ children }) => {
  return (
    <>
      <DashboardNavbar />
      {children}
      <GoogleTranslate />
    </>
  );
};

export default DashboardLayout;
